import React, { Fragment, useState, useEffect } from "react";
import MomentUtils from '@date-io/moment';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Col, Row, Button } from 'reactstrap';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import ExcelReportFees from './ExcelReportFees';
import moment from 'moment';
import ExpensesList from "./ExpensesList";
import ExpensesListActions from "./ExpensesListActions";
import Spinner from 'react-bootstrap/Spinner';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

const ReportFees = ({ }) => {

    //Filtrado de Honorarios
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [plan, setPlan] = useState(null);
    const [service, setService] = useState(null);

    //Datos de Filtrado
    const [plans, setPlans] = useState([]);
    const [services, setServices] = useState([]);
    const [feesExpenses, setFeesExpenses] = useState([]);
    const [clinicData, setClinicData] = useState(null);

    //Loading
    const [loading, setLoading] = useState(false);

    useEffect(() => {

    }, []);

    const handlerChangeStartDate = (date) => {
        setStartDate(date);
    }

    const handlerChangeEndDate = (date) => {
        setEndDate(date);
    }

    const generateFeeReport = async () => {
        setLoading(true);
        let inicio = moment(startDate).format('YYYY-MM-DD');
        let fin = moment(endDate).format('YYYY-MM-DD');
        let dataSend = {
            fecha_inicio: moment(inicio + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fin + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            id_plan: plan,
            id_servicio: service
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'honorarios/calcular-honorarios', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error generando los honorarios');
            }
        }).then(data => {
            setFeesExpenses(data.honorarios);
            setClinicData(data.clinica);
            setLoading(false);
        }).catch(err => {
            alert("Ha ocurrido un error generando los honorarios");
            setLoading(false);
            console.log(err);
        })
    }

    const confirmateMedicalFee = (id_profesional) => {
        setLoading(true);
        let newData = feesExpenses.filter(dat => dat.id_profesional != id_profesional);
        setFeesExpenses(newData);
        setLoading(false);
    }

    const exportGeneralExcel = (data) => {
        ExcelReportFees.exportExcel(data);
    }

    const ListExpenses = () => {
        return (<ExpensesList reactTableData={feesExpenses} ReactTableActions={ExpensesListActions} clinicData={clinicData} confirmateMedicalFee={(id_profesional) => confirmateMedicalFee(id_profesional)} />);
    }

    return (
        <Fragment>

            <Row>
                <Col md={12}>
                    <h5 style={{ color: '#757575' }}>
                        Generación de Reporte de Honorarios
                    </h5>
                    <br />
                </Col>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <DatePicker
                                disableFuture
                                openTo="date"
                                label="Fecha Inicial"
                                views={["year", "month", "date"]}
                                value={startDate}
                                onChange={(date) => {
                                    handlerChangeStartDate(date);
                                }}
                                className='medical-material-form__field'
                                animateYearScrolling
                                format="yyyy/MM/D"
                                variant="inline"
                                autoOk={true}
                            />
                        </ThemeProvider>
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <DatePicker
                                disableFuture
                                openTo="date"
                                label="Fecha Final"
                                views={["year", "month", "date"]}
                                value={endDate}
                                onChange={(date) => {
                                    handlerChangeEndDate(date);
                                }}
                                className='medical-material-form__field'
                                animateYearScrolling
                                format="yyyy/MM/D"
                                autoOk={true}
                                variant="inline"
                            />
                        </ThemeProvider>
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <Button
                        style={{ marginRight: 10, marginLeft: 10, float: 'left' }}
                        color="primary"
                        variant="contained"
                        onClick={() => {
                            generateFeeReport();
                        }}
                    >
                        Consultar
                    </Button>
                </Col>

            </Row>
            <br />

            {
                loading == true ? <div className="text-center"><Spinner style={{ width: '24px', height: '24px' }} animation="border" variant="success" /></div> : <ListExpenses />
            }

            <br />

        </Fragment>
    );
}
export default ReportFees;